module.exports = __webpack_public_path__ + "static/FoodPage-f1ae6c66c7f025bb5cc0705301d12643.jpg";